import { render, staticRenderFns } from "./hotkeysDialog.vue?vue&type=template&id=78d36219&scoped=true&"
import script from "./hotkeysDialog.vue?vue&type=script&lang=js&"
export * from "./hotkeysDialog.vue?vue&type=script&lang=js&"
import style0 from "./hotkeysDialog.vue?vue&type=style&index=0&id=78d36219&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d36219",
  null
  
)

export default component.exports